import React from 'react';
import Translate from "../../../../../components/Translate";
import BlueButton from "../../../../../components-new/buttons/BlueButton";
import config from "../../../../../config";
import TicketPopup from "../TicketPopup";
import DeleteButton from "../../../../../components-new/buttons/actions/DeleteButton";

const Tickets = ({
                     user,
                     company,
                     styles,
                     allowDrop,
                     onDrop,
                     ticketColumns,
                     onDragStart,
                     openPopup,
                     handleDeleteTicket,
                     updatePopupContent,
                     showConversationHistory,
                     isPopupOpen,
                     closePopup,
                     popupContent,
                     addNotification
                 }) => {
    return (
        <div style={styles.fullWidthContainer}>
            <div style={styles.fullWidthCard}>
                <div style={styles.rowTicket}>


                    {['toDo', 'inProgress', 'done'].map((column) => (
                        <div
                            key={column}
                            style={styles.ticketColumn}
                            onDrop={(event) => onDrop(event, column)}
                            onDragOver={allowDrop}
                        >
                            <h3 className="status-heading">{column.replace(/([A-Z])/g, ' $1')
                                .toUpperCase()}</h3>
                            {ticketColumns[column].map((ticket) => (
                                <div
                                    key={ticket.id}
                                    style={styles.ticketCard}
                                    draggable
                                    onDragStart={(event) => onDragStart(event, ticket.id, column)}
                                >
                                    <h4 style={styles.ticketTitle}>{ticket.subject}</h4>
                                    <p style={styles.ticketCategory}>{ticket.categoryName}</p>
                                    <p style={styles.ticketCategory}>{ticket.assignedUser !== null ? ticket.assignedUser.firstName + ' ' + ticket.assignedUser.lastName : ''}</p>
                                    <BlueButton type={'button'} onClick={() => openPopup(ticket)}
                                                styles={{fontSize: '12px'}} height={'none'} width={'90px'}
                                                children={<Translate text="more"/>}/>
                                    {(user.role === config.rolesMap.owner || user.role === config.rolesMap.admin) && (
                                        <DeleteButton
                                            onClick={() => {
                                                handleDeleteTicket(ticket.id, column);
                                            }}
                                            styles={{
                                                position: 'absolute',
                                                top: '15px',
                                                right: '15px',
                                            }}
                                            variant="outline"
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            <TicketPopup updatePopupContent={updatePopupContent}
                         addNotification={addNotification}
                         users={company.members.filter(m => m.status === config.statusMap.enabled)} user={user}
                         isOpen={isPopupOpen} onClose={closePopup} content={popupContent}/>
        </div>
    );
};

export default Tickets;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/my-history/components/Tickets.jsx